import { render, staticRenderFns } from "./PerimeterForm.vue?vue&type=template&id=b0275198"
import script from "./PerimeterForm.vue?vue&type=script&lang=js"
export * from "./PerimeterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports